// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compact-booking-host {
  position: relative;
  margin: 10px 0;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
}

.spinner-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.065);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.compact-booking-sliding ion-item-options .myBookings-sliding-options {
  margin: 1px;
  color: black;
  border-radius: 10px;
  font-size: 12px;
  padding: 0 7px;
}
.compact-booking-sliding ion-item-options .myBookings-sliding-options ion-icon {
  font-size: 24px;
}

:host ::ng-deep .compact-booking-sliding ion-item-option.myBookings-sliding-options::part(native) {
  border-radius: 10px;
}

.compact-booking-item {
  position: relative;
  --min-height: 90px;
}
.compact-booking-item::part(native) {
  --inner-padding-end: 0;
  --padding-end: 0;
}
.compact-booking-item .compact-layout {
  width: 100%;
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.compact-booking-item .new-event-icon {
  position: absolute;
  color: orange;
  top: 5px;
  right: 5px;
  z-index: 3;
  font-size: 13px;
}
.compact-booking-item .compact-top {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
  gap: 8px;
  padding-right: 10px;
}
.compact-booking-item .compact-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.compact-booking-item .compact-title-row {
  display: flex;
  align-items: center;
  gap: 5px;
}
.compact-booking-item .compact-title-row .compact-subject {
  font-size: 14px;
  font-weight: 600;
  color: black;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.compact-booking-item .compact-title-row .compact-subject.cancelled .prefix {
  color: #666;
  margin-right: 3px;
  font-weight: bolder;
}
.compact-booking-item .compact-title-row .compact-subject.cancelled .body {
  text-decoration: line-through;
  color: #666;
}
.compact-booking-item .compact-title-row .series-icon {
  flex-shrink: 0;
  font-size: 14px;
  color: black;
  cursor: pointer;
}
.compact-booking-item .compact-title-row .teams-icon {
  width: 14px;
  height: 14px;
  object-fit: contain;
  flex-shrink: 0;
}
.compact-booking-item .compact-title-row .expired-chip,
.compact-booking-item .compact-title-row .running-chip {
  flex-shrink: 0;
  min-height: unset;
  padding: 0 5px;
  margin: 0;
  border-radius: 4px;
}
.compact-booking-item .compact-title-row .expired-chip ion-label,
.compact-booking-item .compact-title-row .running-chip ion-label {
  font-size: 10px;
  font-weight: 600;
  margin: 0;
}
.compact-booking-item .compact-location-row {
  display: flex;
  align-items: center;
  gap: 4px;
}
.compact-booking-item .compact-location-row .location-pin {
  flex-shrink: 0;
  font-size: 11px;
  color: #ed143d;
}
.compact-booking-item .compact-location-row .location-name {
  font-size: 10px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
}
.compact-booking-item .compact-location-row .status-chip {
  flex-shrink: 0;
  font-size: 12px;
  margin: 0;
}
.compact-booking-item .compact-invited-by-row {
  display: flex;
  align-items: center;
  min-width: 0;
}
.compact-booking-item .compact-invited-by-row .invited-by-line {
  font-size: 10px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
}
.compact-booking-item .compact-bottom-row {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
}
.compact-booking-item .compact-timer {
  flex: 1;
  min-width: 0;
  margin-bottom: 1px;
}
.compact-booking-item .compact-bottom-actions {
  display: flex;
  align-items: end;
  gap: 0;
}
.compact-booking-item .compact-action-button {
  width: 100px;
  height: 38px;
  margin: 0;
  text-transform: none;
}
.compact-booking-item .compact-action-button .content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.compact-booking-item .compact-action-button .content ion-icon {
  font-size: 20px;
}
.compact-booking-item .compact-action-button .content .extend-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  flex-shrink: 0;
}
.compact-booking-item .compact-action-button::part(native) {
  border-radius: 0;
  border-top-left-radius: 15px;
}
.compact-booking-item .compact-action-button.with-extend-meeting {
  height: 30px;
  margin-bottom: 1px;
  margin-right: -10px;
}
.compact-booking-item .compact-action-button.with-extend-meeting .content {
  font-size: 10px;
}
.compact-booking-item .compact-action-button.with-extend-meeting .content ion-icon {
  font-size: 18px;
}
.compact-booking-item .compact-action-button.check-out-button {
  --background: #ed143d;
  --background-hover: #d91237;
  --background-activated: #c01031;
  --background-focused: #d91237;
  --ripple-color: rgba(255, 255, 255, 0.35);
}
.compact-booking-item .compact-action-button.loading {
  --background: #FFC409;
  --background-hover: #FFC409;
  --background-activated: #FFC409;
  --background-focused: #FFC409;
}
.compact-booking-item .compact-action-button.extend-button {
  --background: #fefefe;
  --background-hover: #f6f6f6;
  --background-activated: #efefef;
  --background-focused: #f6f6f6;
  --ripple-color: rgba(0, 0, 0, 0.12);
}
.compact-booking-item .compact-action-button.extend-button .content {
  color: #787878;
}
.compact-booking-item .compact-action-button.extend-button::part(native) {
  border-top-left-radius: 11px;
  box-shadow: -2px 2px 20px 0px rgba(0, 0, 0, 0.1490196078);
}
.compact-booking-item .compact-action-button.extend-button ion-icon {
  font-size: 11px;
}
.compact-booking-item .compact-timing {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  margin-bottom: 0;
  font-size: 11px;
  font-weight: 500;
  color: #666;
  white-space: nowrap;
  min-width: 84px;
}
.compact-booking-item .compact-timing .time-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}
.compact-booking-item .compact-timing .clock-icon {
  font-size: 14px;
  color: #666;
}
.compact-booking-item .compact-timing .time-values {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.4;
}
.compact-booking-item .compact-actions {
  display: flex;
  align-items: center;
  align-self: center;
  color: #737373;
}
.compact-booking-item .compact-actions .chevron-icon {
  font-size: 20px;
}

ion-popover.info-popover::part(content) {
  min-width: unset;
  width: -webkit-fit-content;
  width: fit-content;
}

ion-popover.info-popover {
  --max-height: 40vh;
  --min-width: 240px;
}
ion-popover.info-popover .resource-response-tip {
  display: flex;
  align-items: center;
  gap: 8px;
}
ion-popover.info-popover .resource-response-tip ion-icon {
  font-size: 22px;
  flex-shrink: 0;
}
ion-popover.info-popover .resource-response-tip ion-label {
  margin: 0;
}

.tip-container {
  margin: 8px 13px 8px 13px;
  font-size: 14px;
}

.tip-container.resource-response-tip {
  display: flex;
  align-items: center;
  gap: 8px;
}
.tip-container.resource-response-tip ion-icon {
  font-size: 22px;
  flex-shrink: 0;
}
.tip-container.resource-response-tip ion-label {
  margin: 0;
}

ion-popover.compact-series-popover {
  --width: 90%;
  --min-height: 0;
}
ion-popover.compact-series-popover::part(content) {
  left: 5%;
}
ion-popover.compact-series-popover .series-info-container {
  margin: 8px 13px;
  font-size: 14px;
}

ion-popover.compact-extend-meeting-popover {
  --width: 325px;
  --height: unset;
}
ion-popover.compact-extend-meeting-popover .extend-meeting-container {
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
ion-popover.compact-extend-meeting-popover .title-label {
  text-align: center;
  font-weight: 600;
}
ion-popover.compact-extend-meeting-popover .extend-meeting-options {
  margin: 0 auto;
}
ion-popover.compact-extend-meeting-popover .extend-meeting-options ion-chip {
  padding: 4px 8px;
  min-height: unset;
}
ion-popover.compact-extend-meeting-popover .extend-meeting-error-note {
  text-align: center;
  font-size: 12px;
  color: #ed143d !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/my-bookings-item-compact/my-bookings-item-compact.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,cAAA;EACA,sCAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAII;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AADN;AAGM;EACE,eAAA;AADR;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,kBAAA;AAJF;AAOE;EACE,sBAAA;EACA,gBAAA;AALJ;AAQE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EAEA,sBAAA;AAPJ;AAWE;EACE,kBAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AATJ;AAYE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;AAVJ;AAaE;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAXJ;AAcE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAZJ;AAcI;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAZN;AAeQ;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;AAbV;AAgBQ;EACE,6BAAA;EACA,WAAA;AAdV;AAmBI;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AAjBN;AAoBI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAlBN;AAqBI;;EAEE,cAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;AAnBN;AAqBM;;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AAlBR;AAuBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AArBJ;AAuBI;EACE,cAAA;EACA,eAAA;EACA,cAAA;AArBN;AAwBI;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,OAAA;EACA,YAAA;AAtBN;AAyBI;EACE,cAAA;EACA,eAAA;EACA,SAAA;AAvBN;AA2BE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAzBJ;AA2BI;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,OAAA;EACA,YAAA;AAzBN;AA6BE;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,QAAA;EACA,WAAA;AA3BJ;AA8BE;EACE,OAAA;EACA,YAAA;EACA,kBAAA;AA5BJ;AA+BE;EACE,aAAA;EACA,gBAAA;EACA,MAAA;AA7BJ;AAgCE;EACE,YAAA;EACA,YAAA;EACA,SAAA;EACA,oBAAA;AA9BJ;AAgCI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA9BN;AA+BM;EACE,eAAA;AA7BR;AAgCM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AA9BR;AAoCI;EACE,gBAAA;EACA,4BAAA;AAlCN;AAqCI;EAEE,YAAA;EACA,kBAAA;EACA,mBAAA;AApCN;AAqCM;EACE,eAAA;AAnCR;AAoCQ;EACE,eAAA;AAlCV;AAuCI;EACE,qBAAA;EACA,2BAAA;EACA,+BAAA;EACA,6BAAA;EACA,yCAAA;AArCN;AAwCI;EACE,qBAAA;EACA,2BAAA;EACA,+BAAA;EACA,6BAAA;AAtCN;AAyCI;EACE,qBAAA;EACA,2BAAA;EACA,+BAAA;EACA,6BAAA;EACA,mCAAA;AAvCN;AAwCM;EACE,cAAA;AAtCR;AAwCM;EACE,4BAAA;EACA,yDAAA;AAtCR;AAwCM;EACE,eAAA;AAtCR;AA2CE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AAzCJ;AA2CI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AAzCN;AA4CI;EACE,eAAA;EACA,WAAA;AA1CN;AA6CI;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;AA3CN;AA+CE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AA7CJ;AA+CI;EACE,eAAA;AA7CN;;AAoDA;EACE,gBAAA;EACA,0BAAA;EAAA,kBAAA;AAjDF;;AAoDA;EACE,kBAAA;EACA,kBAAA;AAjDF;AAkDE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAhDJ;AAkDI;EACE,eAAA;EACA,cAAA;AAhDN;AAmDI;EACE,SAAA;AAjDN;;AAsDA;EACE,yBAAA;EACA,eAAA;AAnDF;;AAsDA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAnDF;AAqDE;EACE,eAAA;EACA,cAAA;AAnDJ;AAsDE;EACE,SAAA;AApDJ;;AAwDA;EACE,YAAA;EACA,eAAA;AArDF;AAuDE;EACE,QAAA;AArDJ;AAwDE;EACE,gBAAA;EACA,eAAA;AAtDJ;;AA0DA;EACE,cAAA;EACA,eAAA;AAvDF;AAyDE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAvDJ;AA0DE;EACE,kBAAA;EACA,gBAAA;AAxDJ;AA2DE;EACE,cAAA;AAzDJ;AA2DI;EACE,gBAAA;EACA,iBAAA;AAzDN;AA6DE;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;AA3DJ","sourcesContent":[".compact-booking-host {\n  position: relative;\n  margin: 10px 0;\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);\n}\n\n.spinner-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.065);\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.compact-booking-sliding {\n  ion-item-options {\n    .myBookings-sliding-options {\n      margin: 1px;\n      color: black;\n      border-radius: 10px;\n      font-size: 12px;\n      padding: 0 7px;\n\n      ion-icon {\n        font-size: 24px;\n      }\n    }\n  }\n}\n\n:host ::ng-deep .compact-booking-sliding ion-item-option.myBookings-sliding-options::part(native) {\n  border-radius: 10px;\n}\n\n.compact-booking-item {\n  position: relative;\n  --min-height: 90px;\n\n\n  &::part(native) {\n    --inner-padding-end: 0;\n    --padding-end: 0;\n  }\n\n  .compact-layout {\n    width: 100%;\n    min-width: 0;\n    height: 100%;\n    display: flex;\n    // justify-content: center;\n    flex-direction: column;\n    // padding-top: 10px;\n  }\n\n  .new-event-icon {\n    position: absolute;\n    color: orange;\n    top: 5px;\n    right: 5px;\n    z-index: 3;\n    font-size: 13px;\n  }\n\n  .compact-top {\n    display: flex;\n    align-items: center;\n    min-width: 0;\n    flex: 1;\n    gap: 8px;\n    padding-right: 10px;\n  }\n\n  .compact-content {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  .compact-title-row {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n\n    .compact-subject {\n      font-size: 14px;\n      font-weight: 600;\n      color: black;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n\n      &.cancelled {\n        .prefix {\n          color: #666;\n          margin-right: 3px;\n          font-weight: bolder;\n        }\n\n        .body {\n          text-decoration: line-through;\n          color: #666;\n        }\n      }\n    }\n\n    .series-icon {\n      flex-shrink: 0;\n      font-size: 14px;\n      color: black;\n      cursor: pointer;\n    }\n\n    .teams-icon {\n      width: 14px;\n      height: 14px;\n      object-fit: contain;\n      flex-shrink: 0;\n    }\n\n    .expired-chip,\n    .running-chip {\n      flex-shrink: 0;\n      min-height: unset;\n      padding: 0 5px;\n      margin: 0;\n      border-radius: 4px;\n\n      ion-label {\n        font-size: 10px;\n        font-weight: 600;\n        margin: 0;\n      }\n    }\n  }\n\n  .compact-location-row {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    .location-pin {\n      flex-shrink: 0;\n      font-size: 11px;\n      color: #ed143d;\n    }\n\n    .location-name {\n      font-size: 10px;\n      color: #666;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      flex: 1;\n      min-width: 0;\n    }\n\n    .status-chip {\n      flex-shrink: 0;\n      font-size: 12px;\n      margin: 0;\n    }\n  }\n\n  .compact-invited-by-row {\n    display: flex;\n    align-items: center;\n    min-width: 0;\n\n    .invited-by-line {\n      font-size: 10px;\n      color: #666;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      flex: 1;\n      min-width: 0;\n    }\n  }\n\n  .compact-bottom-row {\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-end;\n    gap: 8px;\n    width: 100%;\n  }\n\n  .compact-timer {\n    flex: 1;\n    min-width: 0;\n    margin-bottom: 1px;\n  }\n\n  .compact-bottom-actions {\n    display: flex;\n    align-items: end;\n    gap: 0;\n  }\n\n  .compact-action-button {\n    width: 100px;\n    height: 38px;\n    margin: 0;\n    text-transform: none;\n\n    .content {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 3px;\n      color: #fff;\n      font-size: 12px;\n      font-weight: 600;\n      white-space: nowrap;\n      ion-icon {\n        font-size: 20px;\n    }\n\n      .extend-icon {\n        width: 16px;\n        height: 16px;\n        object-fit: contain;\n        flex-shrink: 0;\n      }\n    }\n\n\n\n    &::part(native) {\n      border-radius: 0;\n      border-top-left-radius: 15px;\n    }\n\n    &.with-extend-meeting {\n      // width: 158px;\n      height: 30px;\n      margin-bottom: 1px;\n      margin-right: -10px;\n      .content {\n        font-size: 10px;\n        ion-icon {\n          font-size: 18px;\n        }\n      }\n    }\n\n    &.check-out-button {\n      --background: #ed143d;\n      --background-hover: #d91237;\n      --background-activated: #c01031;\n      --background-focused: #d91237;\n      --ripple-color: rgba(255, 255, 255, 0.35);\n    }\n    \n    &.loading {\n      --background: #FFC409;\n      --background-hover: #FFC409;\n      --background-activated: #FFC409;\n      --background-focused: #FFC409;\n    }\n\n    &.extend-button {\n      --background: #fefefe;\n      --background-hover: #f6f6f6;\n      --background-activated: #efefef;\n      --background-focused: #f6f6f6;\n      --ripple-color: rgba(0, 0, 0, 0.12);\n      .content {\n        color: #787878;\n      }\n      &::part(native) {\n        border-top-left-radius: 11px;\n        box-shadow: -2px 2px 20px 0px #00000026;\n      }\n      ion-icon {\n        font-size: 11px;\n      }\n    }\n  }\n\n  .compact-timing {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 4px;\n    margin-bottom: 0;\n    font-size: 11px;\n    font-weight: 500;\n    color: #666;\n    white-space: nowrap;\n    min-width: 84px;\n\n    .time-row {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 4px;\n    }\n\n    .clock-icon {\n      font-size: 14px;\n      color: #666;\n    }\n\n    .time-values {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n      line-height: 1.4;\n    }\n  }\n\n  .compact-actions {\n    display: flex;\n    align-items: center;\n    align-self: center;\n    color: #737373;\n\n    .chevron-icon {\n      font-size: 20px;\n    }\n  }\n}\n\n\n\nion-popover.info-popover::part(content) {\n  min-width: unset;\n  width: fit-content;\n}\n\nion-popover.info-popover {\n  --max-height: 40vh;\n  --min-width: 240px;\n  .resource-response-tip {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    ion-icon {\n      font-size: 22px;\n      flex-shrink: 0;\n    }\n\n    ion-label {\n      margin: 0;\n    }\n  }\n}\n\n.tip-container {\n  margin: 8px 13px 8px 13px;\n  font-size: 14px;\n}\n\n.tip-container.resource-response-tip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  ion-icon {\n    font-size: 22px;\n    flex-shrink: 0;\n  }\n\n  ion-label {\n    margin: 0;\n  }\n}\n\nion-popover.compact-series-popover {\n  --width: 90%;\n  --min-height: 0;\n\n  &::part(content) {\n    left: calc((100% - 90%) / 2);\n  }\n\n  .series-info-container {\n    margin: 8px 13px;\n    font-size: 14px;\n  }\n}\n\nion-popover.compact-extend-meeting-popover {\n  --width: 325px;\n  --height: unset;\n\n  .extend-meeting-container {\n    padding: 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .title-label {\n    text-align: center;\n    font-weight: 600;\n  }\n\n  .extend-meeting-options {\n    margin: 0 auto;\n\n    ion-chip {\n      padding: 4px 8px;\n      min-height: unset;\n    }\n  }\n\n  .extend-meeting-error-note {\n    text-align: center;\n    font-size: 12px;\n    color: #ed143d !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
